<mat-card class="data-table-card">
	<mat-card-header class="data-table-card-header overflow-hidden">
		<div class="overflow-x-auto h-full -ml-4 -mb-2 pb-2 flex flex-auto text-nowrap">
			<div
				(matSortChange)="changeDataSort($event)"
				[matSortActive]="activeSort?.active"
				[matSortDirection]="activeSort?.direction"
				class="mx-3 flex items-center space-x-2 [&>div]:rounded-t"
				matSort
			>
				<div
					class="cursor-pointer p-2 wflex-[0_0_300px]"
					mat-sort-header="name"
					matRipple
				>
					<span translate>utils.name</span>
				</div>
				@if (rulebreaksAudit) {
				<div class="cursor-pointer p-2 wflex-[0_0_160px]"><span translate>supervisor.rulebreaks</span></div>
				} @else {
				<div
					class="cursor-pointer p-2 wflex-[0_0_160px]"
					mat-sort-header="schedules"
					matRipple
				>
					<span>{{
						((data$Visible | async).filterActive && (workspaceScheduleEnabled | async) )? ('schedules.dashboard.total' | translate) : ('schedules.dashboard.is' | translate)
					}}</span>
				</div>
				@if ((data$Visible | async).filterActive && workspaceScheduleEnabled | async) {
				<div
					class="cursor-pointer p-2 wflex-[0_0_160px]"
					mat-sort-header="schedules.difference"
					matRipple
				>
					<span translate>schedules.dashboard.difference</span>
				</div>
				<div
					class="cursor-pointer p-2 wflex-[0_0_160px]"
					mat-sort-header="schedules.future"
					matRipple
				>
					<span translate>schedules.dashboard.future</span>
				</div>
				} }
			</div>
		</div>
	</mat-card-header>
	<mat-card-content>
		<div class="flex flex-col justify-stretch gap-3 pb-3">
			<ng-container *ngIf="data$ | async as entries">
				<ng-container *ngIf="entries.length > 0; else noEntries">
					<cdk-virtual-scroll-viewport
						[itemSize]="58"
						class="scroll-y flex h-[600px] flex-col"
					>
						<mat-accordion
							[hideToggle]="true"
							[multi]="true"
							matExpandableCards
						>
							<ng-container
								*cdkVirtualFor="let entry of entries; let last = last; let index = index; trackBy: trackByUserId"
							>
								<ng-container
									*ngTemplateOutlet="timesItem; context: { item: entry, last: last, index: index }"
								></ng-container>
							</ng-container>
						</mat-accordion>
					</cdk-virtual-scroll-viewport>
				</ng-container>
			</ng-container>
		</div>
	</mat-card-content>
</mat-card>
<ng-template
	#timesItem
	let-index="index"
	let-item="item"
	let-last="last"
>
	<mat-expansion-panel
		[class.brd-b]="!lastHeader"
		class="mat-expansion-card-flat !inline-flex flex-col min-w-full"
		matVirtualExpandable
		togglePosition="before"
	>
		<mat-expansion-panel-header
			(contextmenu)="
        item.user &&
          openContextMenu($event, contextMenuTrigger, {
            user: item.user,
            editable: item.editable,
          })
      "
			collapsedHeight="58px"
			expandedHeight="58px"
		>
			<div
				*ngIf="!(isLoading$ | async); else loadingItems"
				class="flex items-center space-x-2"
			>
				<div class="flex truncate wflex-[0_0_300px]">
					<div class="flex flex-auto flex-col truncate">
						<div class="flex items-center space-x-4">
							<div class="h-10 w-10 flex-shrink-0">
								<app-user-avatar
									[userId]="item.user.id"
									class="rounded-full"
									size="100%"
								></app-user-avatar>
							</div>
							<span class="line-clamp-2 whitespace-pre-line leading-[1.185]">{{
								item.user.name | parseName
							}}</span>
						</div>
					</div>
				</div>
				<div
					*ngIf="{ diff: item.difference } as x"
					class="flex flex-auto items-center space-x-2"
				>
					@if (!rulebreaksAudit) {
					<div class="items-baseline wflex-[0_0_160px]">
						<span>{{ item.summed | parseMsAsDuration: false : true }}</span>
						@if(workspaceScheduleEnabled | async) {
						<span class="mat-hint text-sm">/{{ item.cap | parseMsAsDuration: false : true }}</span>
						}
					</div>
					@if ((data$Visible | async).filterActive && workspaceScheduleEnabled | async ) {
					<span
						[ngClass]="{
					'text-warn': x.diff < 0,
					'text-success': x.diff > 0,
					'text-muted': x.diff === 0,
					}"
						class="wflex-[0_0_160px]"
					>
						{{ x.diff > 0 ? '+' : x.diff === 0 ? '' : '-' }}
						{{ x.diff | parseMsAsDuration: false : false }}
					</span>
					<div class="wflex-[0_0_160px]">
						<span class="mat-text-primary">{{
							item.future | clamp: 0 | parseMsAsDuration: false : true
						}}</span>
					</div>
					} } @if (item.errorCount) {
					<div
						[matTooltipTemplate]="whErrorTooltip"
						[matTooltipTemplateContext]="{ errors: item.errors }"
						[ngClass]="{ 'w-10 justify-center place-self-center': !rulebreaksAudit, 'space-x-4': rulebreaksAudit }"
						class="flex h-10 items-center"
						matTooltip
					>
						<mat-icon color="accent">warning</mat-icon>
						@if (rulebreaksAudit) {<span>{{
							'supervisor.rulebreaks_count' | translate: { value: item.errorCount }
						}}</span
						>}
					</div>
					}
				</div>
			</div>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="flex flex-col">
				<ng-container
					*ngTemplateOutlet="worktimeEntriesHeader; context: { count: item.times?.length }"
				></ng-container>
				<ng-container *ngIf="!(isLoading$ | async); else worktimeLoading">
					<ng-container *ngIf="item.times?.length && item.times as times; else noEntries">
						<cdk-virtual-scroll-viewport
							[itemSize]="48"
							[style.height.px]="times.length > 10 ? 600 : (times.length * 48).clampThis(100)"
							class="flex flex-col"
						>
							<ng-container *cdkVirtualFor="let entry of times; trackBy: trackId">
								<ng-container
									*ngTemplateOutlet="worktimeEntryTemplate; context: { time: entry }"
								></ng-container>
							</ng-container>
						</cdk-virtual-scroll-viewport>
					</ng-container>
				</ng-container>
			</div>
		</ng-template>
	</mat-expansion-panel>
</ng-template>
<ng-template #worktimeLoading>
	<div class="flex flex-col space-y-1">
		<div
			*ngFor="let item of loadingRows"
			class="grid h-12 grid-cols-[200px_100px_100px_100px_160px] items-center gap-x-2 px-6 [&>div]:h-6"
		>
			<div class="mat-skeleton"></div>
			<div class="mat-skeleton"></div>
			<div class="mat-skeleton"></div>
			<div class="mat-skeleton"></div>
			<div class="mat-skeleton"></div>
		</div>
	</div>
</ng-template>
<ng-template
	#worktimeEntriesHeader
	let-itemCount="count"
>
	<div
		class="mat-hint px-6 mb-2 grid h-8 grid-cols-[200px_100px_100px_100px_160px_1fr] items-start space-x-2 border-b border-b-neutral-300 text-sm font-semibold dark:border-b-neutral-700"
	>
		<div>{{ 'comego.typeColumn' | translate }}</div>
		<div>{{ 'timer.time.start' | translate }}</div>
		<div>{{ 'timer.time.end' | translate }}</div>
		<div>{{ 'timer.time.duration' | translate }}</div>
		<div>{{ 'timer.date' | translate }}</div>
		<div class="flex-auto flex justify-end">
			@if (itemCount >= 0) {
			<div>{{ 'utils.itemCount' | translate: { count: itemCount } }}</div>
			}
		</div>
	</div>
</ng-template>
<ng-template #notWorkingDay>
	<div><span>-</span></div>
</ng-template>
<ng-template
	#worktimeEntryTemplate
	let-item="time"
>
	<div
		(click)="item.editable && (!isLocked(item.start, item) || lookingAtSubordinate(item?.user?.id)) && editItem(item)"
		[class.opacity-50]="isLocked(item.start, item) && !lookingAtSubordinate(item?.user?.id)"
		[ngClass]="{
      'mat-bg-3-hover cursor-pointer': item.editable,
    }"
		class="grid h-12 grid-cols-[200px_100px_100px_100px_160px_60px_100px] items-center space-x-2 px-6"
	>
		<div class="flex items-start space-x-2">
			<div
				[ngClass]="
          item?.type?.name === 'work'
            ? ' border  border-green-400  bg-green-600/90  dark:bg-green-600/60  text-green-200'
            : item?.type?.name === 'absence'
              ? 'border  border-violet-400  bg-violet-800/90  dark:bg-violet-800/60  text-violet-100'
              : item?.type?.name === 'pause'
                ? '  dark:bg-neutral-600 bg-neutral-600/80'
                : '  border  border-violet-400  bg-violet-800/90  dark:bg-violet-800/60  text-violet-100'
        "
				*ngIf="iconMap[item?.type?.name] as type"
				class="mt-0.5 flex size-6 p-0 leading-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100"
			>
				<mat-icon
					class="text-center"
					inline
				>
					{{ type }}
				</mat-icon>
			</div>
			<div
				[ngClass]="[(item.type === 'not_worked' || !item.name) && 'self-center'] | clsx"
				*ngIf="item.type; else projectTimeName"
				class="flex flex-col truncate leading-none"
			>
				<ng-container *ngIf="item?.type?.name === 'not_worked'; else regularWorkingType">
					<span>{{ item.name || 'time.none' | translate }}</span>
				</ng-container>
				<ng-template #regularWorkingType>
					<span>{{ item | workinghoursType }}</span>
					<span
						*ngIf="item.name as name"
						class="mat-hint truncate text-sm"
						>{{
							name
						}}</span
					>
				</ng-template>
			</div>
			<ng-template #projectTimeName>
				<div class="flex flex-col truncate leading-none">
					<span class="truncate">{{ item.name || 'time.none' | translate }}</span>
				</div>
			</ng-template>
		</div>
		<div *ngIf="item.isWorkingDay; else notWorkingDay">{{ item.start | formatDate: 'time' }}</div>
		<div *ngIf="item.isWorkingDay; else notWorkingDay">{{ item.end | formatDate: 'time' }}</div>
		<div *ngIf="item.isWorkingDay; else notWorkingDay">{{ item.duration | parseMsAsDuration }}</div>
		<div>{{ item.start | formatDate: 'date' }}</div>
		@if (item.violations?.length && item.violations; as errors) {
		<div
			[matTooltipTemplate]="whErrorTooltip"
			[matTooltipTemplateContext]="{ errors: errors }"
			class="flex h-10 w-10 items-center justify-center place-self-center"
			matTooltip
		>
			<mat-icon color="accent">warning</mat-icon>
		</div>
		} @else {
		<div></div>
		} @if (item.recording) {<ng-container *ngTemplateOutlet="recordingText"></ng-container>} @else {
		<div></div>
		}
	</div>
</ng-template>
<ng-template #noEntries> <div class="mat-hint py-10 text-center">{{ 'errors.empty' | translate }}</div> </ng-template>
<ng-template #loadingItems>
	<div class="flex items-center space-x-2">
		<div class="wflex-[0_0_300px]">
			<div class="mat-skeleton"></div>
		</div>
		<div class="wflex-[0_0_160px]">
			<div class="mat-skeleton"></div>
		</div>
		<div class="wflex-[0_0_160px]">
			<div class="mat-skeleton"></div>
		</div>
		<div class="wflex-[0_0_160px]">
			<div class="mat-skeleton"></div>
		</div>
	</div>
</ng-template>

<ng-template
	#whErrorTooltip
	let-errors="errors"
>
	<div class="flex flex-col space-y-2">
		<div
			*ngFor="let werr of errors"
			class="flex items-start space-x-2"
		>
			<div class="flex flex-col gap-2">
				<div class="dot mt-1.5 mat-size-1.5"></div>
				@if (werr.count) {
				<div class="text-sm font-medium leading-4 align-middle">x{{ werr.count }}</div>
				}
			</div>
			<div>{{ werr.message | translate: (werr.args | translateArgs) }}</div>
		</div>
	</div>
</ng-template>
<ng-template #blockEdit>
	<div class="flex flex-col space-y-2">
		<div>{{ 'time.blockEdit' | translate }}</div>
	</div>
</ng-template>

<div
	[matMenuTriggerFor]="userContextMenu"
	[style.left]="contextMenuPosition.x"
	[style.top]="contextMenuPosition.y"
	#contextMenuTrigger="matMenuTrigger"
	style="visibility: hidden; position: fixed"
></div>
<mat-menu #userContextMenu="matMenu">
	<ng-template
		let-editable="editable"
		let-user="user"
		matMenuContent
	>
		<div class="flex flex-col gap-1">
			<button
				(click)="setFilterToUser(user.id)"
				mat-menu-item
			>
				<mat-icon inline>person_search</mat-icon>
				Only filter this user
			</button>
			<button
				(click)="openUserSettings(user.id)"
				[disabled]="!editable"
				[matTooltip]="!editable && 'utils.missing_admin' | translate"
				mat-menu-item
			>
				<mat-icon inline>manage_accounts</mat-icon>
				{{ 'workspace.users.edit' | translate }}
			</button>
		</div>
	</ng-template>
</mat-menu>

<ng-template #recordingText>
	<div class="flex animate-pulse items-center space-x-1 text-red-500 flex-shrink-0">
		<div class="size-2 rounded-full bg-red-500 flex-shrink-0"></div>
		<div translate>time.recording</div>
	</div>
</ng-template>
